import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import { useFetch } from '../../hooks/queries';
import CustomLoader from '../../Components/custom/CustomLoader';
import { IoChevronBackCircleOutline } from 'react-icons/io5';

const Grades = () => {
  const { id } = useParams();
  const [perPage, setPerPage] = useState(100);
  const [page, setPage] = useState(1);
  const { state } = useLocation();
  const navigate = useNavigate();

  const { data, isPending, isLoading, isFetching } = useFetch({
    queryKey: ['grades', id, page, perPage],
    url: `${process.env.REACT_APP_API_URL}Courses/GetGrades?AssignmentId=${id}&PageNumber=${page}&PageSize=${perPage}`,
    method: 'PATCH',
  });

  const grades = data?.data || [];
  const totalRows = data?.totalCount || 0;

  const isGradesLoading = isPending || isLoading || isFetching;

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerRowsChange = (newPerPage, newPage) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  const columns = [
    {
      name: 'Student Name',
      selector: (row) => row.name,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Score',
      selector: (row) =>
        row.score === null || row.score === undefined ? 'N/A' : row.score,
      sortable: true,
      width: '120px',
    },
    {
      name: 'Submitted Date',
      selector: (row) =>
        row.submittedDate
          ? moment(row.submittedDate).format('YYYY-MM-DD HH:mm')
          : 'N/A',
      sortable: true,
      width: '200px',
    },
  ];

  return (
    <div className='content'>
      <div className='left-side'>
        <div className='container-fluid mt-30'>
          <div className='table-title-container'>
            <IoChevronBackCircleOutline
              size={25}
              color='#287a9f'
              className='back-btn'
              onClick={() => navigate(-1)}
            />
            <p className='title-table'>{state?.assignmentName}</p>
          </div>
          <div className='card'>
            <div className='card-header'>
              <h3 className='card-title'>Grades</h3>
            </div>
            <div className='card-body p-0'>
              <DataTable
                data={grades}
                columns={columns}
                pagination
                paginationServer={true}
                paginationTotalRows={totalRows}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                paginationPerPage={perPage}
                paginationRowsPerPageOptions={[100, 200, 300, 500]}
                progressPending={isGradesLoading}
                progressComponent={<CustomLoader />}
                fixedHeader
                fixedHeaderScrollHeight={'75vh'}
                defaultSortFieldId={1}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Grades;
